import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';
// import 'plugs/manual-function.js';


var $window = $(window);
var winW,winH,footerH,bodyH,scrollTop;
$(function() {    
    $('body').addClass('fade-in');
    $("#topBtn").click(function() {
        $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
        return false;
    });
    //menu active mode(select this)
    if($('main.team').length > 0){
        $('ul.mmenu > li').eq(0).addClass('active');
    }else if($('main.project').length > 0){
        $('ul.mmenu > li').eq(1).addClass('active');
    }else if($('main.news').length > 0){
        $('ul.mmenu > li').eq(2).addClass('active');
    }else if($('main.materials').length > 0){
        $('ul.mmenu > li').eq(3).addClass('active');
    }else if($('main.contact').length > 0){
        $('ul.mmenu > li').eq(4).addClass('active');
    } 
    //mobile menu
    var menuicon = $('header .menuicon'),
    navBox = $('header .mmenu'),
    nav = $('header .navBox'),
    $body = $('body'),
    $header = $('header');
    menuicon.on('click',function(){
        var $this = $(this);
        if(!$header.hasClass('menu-expanded')){
            $header.addClass('menu-expanded');
            $body.css({'overflow':'hidden'}).addClass('modal_open');
        }else{
            $header.removeClass('menu-expanded');
            $body.css({'overflow':''}).removeClass('modal_open');
        }
        return false;
    });
    //scroll animation
    var win_height_padded = $window.height() * 0.9;
    window.setTimeout(function(){
        $window.on('scroll', revealOnScroll);
        revealOnScroll();
    },300);
    $window.on('resize',function(){
        winW = $window.width();
        winH =  $window.height();
        footerH = $('footer').outerHeight(true);
        bodyH = winH - footerH;  
        //bodyH
        $('main').css('min-height',bodyH);
        if(winW > 991){
            $header.removeClass('menu-expanded');
            $('.navBox').removeAttr('style');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''});
        }
        //background-image
        resizeBgcover(winW);
        //top menu
        if($('#top-menu-ul').length > 0){
            var menu_ul = $('#top-menu-ul ul').width();
            var menu_box = $('#top-menu-ul .item_menu_Box').width()
            
            $('#top-menu-ul').removeClass('open_flexslider');
            $('#top-menu-ul .slides').removeAttr('style');
            $('#top-menu-ul .item_menu_Box').removeAttr('style');
            
            if(menu_ul > menu_box ){
                $('#top-menu-ul').addClass('open_flexslider'); 
            }
            slider_ul_list();
        }

    }).resize();    
    $window.on('scroll', function() {
        scrollTop = $(this).scrollTop();
        gotopfun(scrollTop);
    }).scroll();

    //slick template
    $('.slider-banner').on('init', function(event, slick){
        setTimeout(function(){
            $('.slider-banner').addClass('slickinit');
        },300);
        
    });
    $('.slider-banner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:5000,
        speed:1500,
        fade:true,
        arrows: false,
        dots:true,
        customPaging : function(slider, i) {
            i = i + 1 ;
            var current = (i<10) ?  "0" + i : i;
            return current + '<span></span>';
        },
    });
    $('.slider-fade').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:5000,
        speed:1500,
        fade:true,
        arrows: false,
        dots:true,
        customPaging : function(slider, i) {
            i = i + 1 ;
            var current = (i<10) ?  "0" + i : i;
            return current + '<span></span>';
        },
    });
});